export default __webpack_public_path__ + "static/media/star.79c6195e.svg";